import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';

import { FcpTooltipComponent } from './fcp-tooltip.component';

@NgModule({
    imports: [CommonModule, OverlayModule],
    declarations: [FcpTooltipComponent],
    exports: [FcpTooltipComponent]
})
export class FcpTooltipModule {}
